import * as React from 'react';
import FormContainer from '../../components/Form/FormContainer';
import { httpOption, SERVER_IP } from '../../Util/Config';
import { expired as Language } from '../../Util/language.json';

const DuplicateLogin = () => {

  const delCookie = () => {
    window.$.ajax({
      url: `${SERVER_IP}/cli/user/delCookie`,
      type: 'get',
      ...httpOption,
      xhrFields: {
        withCredentials: true,
      },
    }).then(data => {
      if (data.status === 200) {
        window.location.href = '/tv';
      }
    })
  }

  return (
    <FormContainer caption={Language.caption}>
      <a className="link color-secondary" onClick={delCookie}>
        {Language.home}
      </a>
    </FormContainer>
  )
};

export default DuplicateLogin;
